<template>
  <div class="quote-card">
    <form @submit.prevent="searchQuotes">
      <div class="row">
        <div class="col-xxl-3 col-xl-3 col-lg-4 mb-3">
          <label>Rep Name</label>
          <input type="text" class="viewQuotes-field" name="" placeholder="Enter Rep Name"
            v-model="filters.agent_name" />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-4 mb-3">
          <label>Rep Code</label>
          <input type="text" class="viewQuotes-field" name="" placeholder="Enter Rep Code"
            v-model="filters.agent_code" />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-4 mb-3">
          <label>Quote Sent Status</label>
          <select class="viewQuotes-field" name="" v-model="filters.status">
            <option value="">Select Status</option>
            <option value="Started">Started</option>
            <option value="Not Started">Not Started</option>
            <option value="Completed">Completed</option>
          </select>
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-4 mb-3">
          <div class="enrollment-date">
            <label>Quote Sent Date</label>
            <date-picker input-class="viewQuotes-field" placeholder="Quote sent date" type="date"
              v-model="filters.start_date" value-type="format" format="MM/DD/YYYY"></date-picker>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-xxl-3 col-xl-3 text-end">
            <button type="submit" class="univ-btn mb-0 p-2">Search</button>
          </div>
      </div>
    </form>
    <div>
      <personalized-quote-submit @renderViewList="searchQuotes" />
      <group-quote-submit @renderViewList="searchQuotes" />
    </div>
  </div>
</template>
<script>
import PersonalizedQuoteSubmit from "../modal/PersonalizedIndividualQuote/PersonalizedQuoteSubmit.vue";
import GroupQuoteSubmit from "../../ViewQuotes/modal/PersonalizedGroupQuote/GroupQuoteSubmit.vue";

export default {
  name: "QuoteFilter",
  components: {
    PersonalizedQuoteSubmit,
    GroupQuoteSubmit
  },
  props: {
    filters: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    searchQuotes() {
      this.$emit("onSearch", this.filters);
    }
  },
};
</script>
<style  scoped>
.border-line{
  border-right:1px solid #ccc;
}
.new-quote{
  max-width: 100% !important ;
}
</style>